import { EventFilterParams } from "./EventFilterParams";
import { OfferFilterParams } from "./OfferFilterParams";

export class EventPagingFilterParams extends EventFilterParams {
	offers?: OfferFilterParams | OfferFilterParams[] | null;
}